import React, { useEffect, useReducer } from 'react';
import Context from './context';


type ACTIONTYPE = { type: 'setData'; data: any };

const reducer = (state: any, action: ACTIONTYPE) => {
  switch (action.type) {
    case 'setData':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export enum PageStatus {
  LOADING = 'loading',
  ERROR = 'error',
  NOLOGIN = 'nologin',
  NORMAL  = 'normal',
}

export interface AppState {
    pageStatus: PageStatus;
}

export const GlobalDataProvider = (props: any) => {

  const { children } = props;
  const initState: AppState = {
    pageStatus: PageStatus.LOADING,
  };

  // 初始化reducer
  const [state, dispatch] = useReducer(reducer, initState);
  const GetgeneralConfig = async () => {
  };
  const initApp = () => {
    GetgeneralConfig();
  };
  // 初始化
  useEffect(() => {
    initApp();
  }, []);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};
